import { render, staticRenderFns } from "./SeminarySwitcher.vue?vue&type=template&id=5b7665d2&scoped=true&"
import script from "./SeminarySwitcher.vue?vue&type=script&lang=js&"
export * from "./SeminarySwitcher.vue?vue&type=script&lang=js&"
import style0 from "./SeminarySwitcher.vue?vue&type=style&index=0&id=5b7665d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7665d2",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend-internal/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BButton, BButtonGroup} from 'bootstrap-vue'
    installComponents(component, {BButton, BButtonGroup})
    


    import installDirectives from "!/Users/jurajpetras/dev/pmat/web/frontend-internal/node_modules/bootstrap-vue-loader/lib/runtime/installDirectives.js"
    import {VBPopover} from 'bootstrap-vue'
    installDirectives(component, {'b-popover': VBPopover})
    

export default component.exports